const Axios = require("axios");
const { socketCall } = require("../utils/websocket");

const req = (method, url, options, getRes, timeout = 0) => {
  const { simtopy } = global.store.getState();
  let baseURL = `${simtopy.protocol}//${simtopy.host}`
  // if(process.env.NODE_ENV === "development") {
  //console.log("request", {method, baseURL, url, options});
  // }
  return Axios.request({
    url,
    method,
    baseURL,
    timeout,
    ...options,
  }).then(response => {
    if (getRes) return response;
    else return response.data
  });
}

module.exports = {
  adminCall(action, params, options = {
    timeout: 0
  }) {
    if (process.env.NODE_ENV === "development") {
      console.log(`admin.${action}`, params);
    }
    return socketCall({
      action,
      params,
      ...options
    });
  },
  get(url, options = {}, getRes = false) {
    return req("get", url, options, getRes);
  },
  post(url, options = {}) {
    return req("post", url, options);
  }
}